
import { useState } from 'react'
import './style.scss'
// import { userStateData } from '../../data/userStateData'
import { useAppSelector } from '../../redux/hooks'
import { DashboardSubPages } from '../../types/types'
import { PAGE_URLS } from '../../constants/hrefLinks'

function DashboardSideMenu() {
	const [menuCollapsed, setMenuCollapsed] = useState<boolean>(false)

	const subPage: string = useAppSelector(state => state.dashboard.subPage)

	return (
		<div className={menuCollapsed ? 'dashboard-side-menu-wrap dashboard-side-menu-wrap-collapsed' : 'dashboard-side-menu-wrap'}>
			<div className='dashboard-side-menu-logo-wrap'>
				<a
					className='dashboard-side-menu-logo'
					href={'/'}
				>
					<img
						className='dashboard-side-menu-logo-img'
						src={menuCollapsed ? '/imgs/logos/logo-small-over-colour.svg' : '/imgs/logos/logo-text-white.svg'}
						alt='logo'
					/>
				</a>
				<img
					className={menuCollapsed ? 'dashboard-side-menu-collapse-button dashboard-side-menu-collapse-button-collapsed' : 'dashboard-side-menu-collapse-button'}
					src={`/imgs/icons/dashboard/icon-dashboard-collapse-white.svg`}
					alt='Collapse Button'
					onClick={() => setMenuCollapsed(!menuCollapsed)}
				/>
			</div>
			<div className='dashboard-side-menu-button-wrap'>
				{/* <button
					className={subPage === DashboardSubPages.CHATS ? 'dashboard-side-menu-button dashboard-side-menu-button-selected' : 'dashboard-side-menu-button dashboard-customer-side-menu-button'}
					onClick={() => console.log('chat clicked')}
				>
					<img
						className='dashboard-side-menu-button-icon'
						src={`/imgs/icons/dashboard/icon-dashboard-chat.svg`}
						alt='See Chat Button'
					/>
					{!menuCollapsed && <div className='dashboard-side-menu-button-label dashboard-customer-side-menu-button-label'>See Chats</div>}
				</button> */}
				{/* <button
					className='dashboard-side-menu-button'
					onClick={() => console.log('booking clicked')}
				>
					<img
						className='dashboard-side-menu-button-icon'
						src={`/imgs/icons/dashboard/icon-dashboard-booking.svg`}
						alt='Booking Details Button'
					/>
					{!menuCollapsed && <div className='dashboard-side-menu-button-label dashboard-customer-side-menu-button-label'>Booking Details</div>}
				</button>
				<button
					className='dashboard-side-menu-button'
					onClick={() => console.log('saved clicked')}
				>
					<img
						className='dashboard-side-menu-button-icon'
						src={`/imgs/icons/dashboard/icon-dashboard-saved.svg`}
						alt='Saved Instructors Button'
					/>
					{!menuCollapsed && <div className='dashboard-side-menu-button-label dashboard-customer-side-menu-button-label'>Saved Instructors</div>}
				</button> */}
				<div
					className='dashboard-side-menu-bottom-button-wrap dashboard-customer-side-menu-bottom-button-wrap'
				>
					<button
						className={subPage === DashboardSubPages.SETTINGS ? 'dashboard-side-menu-button dashboard-side-menu-button-selected' : 'dashboard-side-menu-button dashboard-customer-side-menu-button'}
						onClick={() => window.location.replace(PAGE_URLS.DASHBOARD_PROFILE)}
					>
						<img
							className='dashboard-side-menu-button-icon dashboard-side-menu-button-icon-white'
							src={`/imgs/icons/dashboard/icon-dashboard-settings-white.svg`}
							alt='Settings Button'
						/>
						{!menuCollapsed && <div className='dashboard-side-menu-button-label dashboard-customer-side-menu-button-label'>Settings</div>}
					</button>
					<button
						className='dashboard-side-menu-button dashboard-customer-side-menu-button'
						onClick={() => window.location.replace(PAGE_URLS.DASHBOARD_CUSTOMER)}
					>
						<img
							className='dashboard-side-menu-button-icon'
							src={`/imgs/icons/dashboard/icon-dashboard-home-white.svg`}
							alt='Home Button'
						/>
						{!menuCollapsed && <div className='dashboard-side-menu-button-label dashboard-customer-side-menu-button-label'>Home</div>}
					</button>
				</div>
			</div>
		</div>
	)
}

export default DashboardSideMenu
